// eslint-disable-next-line import/no-extraneous-dependencies
import { Button, Grid, OutlinedInput } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  type: string
  setSearchTerm: Function
  searchTerm: any
  setLoading: Function
  getSensors: Function
  setSensors: Function
  setFrom: Function
  setTo: Function
  from: number
  to: number
  setShowError: Function
  setErrorMessage: Function
}


const SearchSensors = ({
  type,
  setSearchTerm,
  searchTerm,
  setLoading,
  getSensors,
  setSensors,
  setFrom,
  setTo,
  from,
  to,
  setShowError,
  setErrorMessage
}: Props) => {
  const { t } = useTranslation();

  return     <div id="header-wrapper">
    <div id="sensor-info">
      {t('SENSOR_TYPE_I')}: <span>{type?.toUpperCase()}</span>
    </div>
    <div id="sensors-search">
      <Grid container spacing={2}>
        <Grid item xs={10}>
          <div className="label">{t('SEARCH_SINGLE_SENSOR')}</div>
          <OutlinedInput
            size="small"
            sx={{
              '& legend': { display: 'none' },
              '& fieldset': { top: 0 }
            }}
            fullWidth
            placeholder={t('Sensor ID')}
            onChange={(event) => {
              setSearchTerm(event.target.value);
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <Button
            variant="contained"
            onClick={async () => {
              if (searchTerm) {
                setLoading(true);
                try {
                  const result = await getSensors([searchTerm]);
                  if (result.data) {
                    setSensors(result?.data);
                    setLoading(false);
                  }
                } catch (error) {
                  setLoading(false);
                }
              }
            }}
            style={{ marginTop: 20, borderRadius: 5 }}
          >
            {t('SEARCH')}
          </Button>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={10}>
          <div className="label">{t('SEARCH_RANGE_SENSORS_FROM')}</div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <OutlinedInput
              type="number"
              size="small"
              sx={{
                '& legend': { display: 'none' },
                '& fieldset': { top: 0 }
              }}
              fullWidth
              placeholder={t('0')}
              onChange={(event) => {
                setFrom(parseInt(event.target.value));
              }}
            />
            <OutlinedInput
              fullWidth
              size="small"
              sx={{
                '& legend': { display: 'none' },
                '& fieldset': { top: 0 }
              }}
              placeholder={t('N')}
              onChange={(event) => {
                setTo(parseInt(event.target.value));
              }}
              type="number"
            />
          </div>
        </Grid>
        <Grid item xs={2}>
          <Button
            variant="contained"
            onClick={async () => {
              if (from !== undefined || to !== undefined) {
                setLoading(true);
                const data = { from: from, to: to };
                try {
                  if (data.from !== undefined || data.to !== undefined) {
                    const fValue = data.from ?? 0;
                    const tValue = data.to ?? fValue + 100;
                    if (tValue - fValue > 900) {
                      setShowError(true);
                      setErrorMessage(t('MAX_SENSORS_RANGE'));
                      setLoading(false);
                      return;
                    }
                  }
                  const result = await getSensors(undefined, from, to);
                  if (result?.data) {
                    setSensors(result.data);
                    setLoading(false);
                  }
                } catch (error: any) {
                  setShowError(true);
                  setErrorMessage(error.response?.data?.errorMessage );
                  setLoading(false);
                }
              }
            }}
            style={{ marginTop: 20, borderRadius: 5 }}
          >
            {t('SEARCH')}
          </Button>
        </Grid>
      </Grid>
    </div>
  </div>;
};

export default SearchSensors;